// @flow
export const getAddressComponents = (
  addressComponents: Array<GeocoderAddressComponent>
): AddressComponents =>
  addressComponents.reduce((hash, component) => {
    const attributeName = component.types[0];
    if (['administrative_area_level_1', 'country'].includes(attributeName)) {
      hash[attributeName] = {
        long: component.long_name,
        short: component.short_name
      };
    } else {
      hash[attributeName] = component.long_name;
    }
    return hash;
  }, {});
